/**
 * PPS REST API Client
 *
 * Singleton RestClient for PPS (Package Price Service) API.
 * All PPS calls are POST with Login: {} (auth via API Gateway).
 */
import { RestClient } from '../shared/restClient';
import { PPS_CONFIG } from './config';

export const ppsClient = new RestClient({
  baseURL: PPS_CONFIG.ENDPOINT,
  timeout: PPS_CONFIG.TIMEOUT,
  retryConfig: {
    retries: PPS_CONFIG.RETRY.maxAttempts,
    retryDelay: (retryCount) => PPS_CONFIG.RETRY.initialDelay * Math.pow(2, retryCount - 1),
  },
});
